import { axios } from '@/utils/request'

export function getCulumList (typeId) {
  return axios({
    url: '/increaseCulum/list/' + typeId,
    method: 'get'
  })
}
export function getTypeList () {
  return axios({
    url: '/increaseCulum/type',
    method: 'get'
  })
}
export function getcontextList (id) {
  return axios({
    url: '/increaseCulum/' + id,
    method: 'get'
  })
}
